import type { ComponentType } from 'react';
import { UtilizationDashboard } from './utilization/utilization-dashboard';

/**
 * What the route hands a dashboard. The dashboard renders `<DashboardShell>`
 * itself (it owns the layout state that the shell's reset button acts on), so
 * it needs the period controls to pass through.
 */
export interface DashboardViewProps {
  dashboard: DashboardDef;
  /** Reporting month as `YYYY-MM`, from the route's search params. */
  period: string;
  onPeriodChange: (period: string) => void;
}

/**
 * A dashboard is one screen's worth of tiles. Adding CPR or EPR later means
 * adding an entry here and its tile component — the route, header, switcher
 * and grid are all dashboard-agnostic and need no change.
 */
export interface DashboardDef {
  /** URL segment: `/dashboard/{id}`. */
  id: string;
  /** Shown in the switcher and as the page title. */
  title: string;
  /** One line under the title. */
  description: string;
  component: ComponentType<DashboardViewProps>;
}

// Non-empty tuple, so `DASHBOARDS[0]` is statically known to exist and
// `DEFAULT_DASHBOARD_ID` can be derived rather than restated.
export const DASHBOARDS: [DashboardDef, ...DashboardDef[]] = [
  {
    id: 'utilization',
    title: 'Team Utilization',
    description: 'How available capacity was spent across locations, segments and engagement type.',
    component: UtilizationDashboard,
  },
];

/** The dashboard `/dashboard` (no id) lands on: always the first registered. */
export const DEFAULT_DASHBOARD_ID = DASHBOARDS[0].id;

export function findDashboard(id: string): DashboardDef | undefined {
  return DASHBOARDS.find((d) => d.id === id);
}
